import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const FRACTIONATOR_CONFIG = {
    type: ERFElement.Fractionator,
    icon: 'Fractionator_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Сырьё',
                    position: Position.Left,
                    style: { top: 160, left: 10, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_top_product',
                    type: 'source',
                    name: 'Верхний продукт',
                    position: Position.Top,
                    style: { top: 9, left: 108, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_water',
                    type: 'source',
                    name: 'Вода',
                    position: Position.Right,
                    style: { top: 150, right: 28, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_intermediate_selections_flows',
                    type: 'source',
                    name: 'Именованный мульти-порт',
                    position: Position.Right,
                    style: { top: 171, right: 28, background: M_FLOW_HEX },
                    connectionCount: 5
                },
                {
                    id: 'source_material_bottom_product',
                    type: 'source',
                    name: 'Нижний продукт',
                    position: Position.Bottom,
                    style: { bottom: 26, left: 38, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 240, left: 10, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 240, right: 72, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFFractionatorNode.config.js.map